module.exports = __webpack_public_path__ + "static/media/armCurl.cd15b9ca.png";